<section class="wrap-report-detail">
  <h5 class="sec-title">Reports Highlights</h5>
  <div class="wrap-card-sec">
    <div *ngIf="industryReport?.total_funding" class="card-sm-wrap">
      <span class="title">Total Fundings</span>
      <span class="number">{{industryReport?.total_funding}}</span>
    </div>
    <div *ngIf="industryReport?.growth_stage_deals" class="card-sm-wrap">
      <span class="title">Growth Stage Deals</span>
      <span class="number">{{industryReport?.growth_stage_deals}}</span>
    </div>
    <div *ngIf="industryReport?.early_stage_deals" class="card-sm-wrap">
      <span class="title">Early Stage Deals</span>
      <span class="number">{{industryReport?.early_stage_deals}}</span>
    </div>
    <div *ngIf="industryReport?.layoffs" class="card-sm-wrap">
      <span class="title">Layoffs</span>
      <span class="number">{{industryReport?.layoffs}}</span>
    </div>
    <div *ngIf="industryReport?.undisclosed_deals" class="card-sm-wrap">
      <span class="title">Undisclosed Deals</span>
      <span class="number">{{industryReport?.undisclosed_deals}}</span>
    </div>
    <div *ngIf="industryReport?.fund_launches" class="card-sm-wrap">
      <span class="title">Fund Launches</span>
      <span class="number">{{industryReport?.fund_launches}}</span>
    </div>
    <div *ngIf="industryReport?.acquisitions" class="card-sm-wrap">
      <span class="title">Acquisitions</span>
      <span class="number">{{industryReport?.acquisitions}}</span>
    </div>
    <div *ngIf="industryReport?.shutdow" class="card-sm-wrap">
      <span class="title">Shutdow</span>
      <span class="number">{{industryReport?.shutdow}}</span>
    </div>
    <div *ngIf="industryReport?.departures" class="card-sm-wrap">
      <span class="title">Departures</span>
      <span class="number">{{industryReport?.departures}}</span>
    </div>
    <div *ngIf="industryReport?.unicorn" class="card-sm-wrap">
      <span class="title">Unicorn</span>
      <span class="number">{{industryReport?.unicorn}}</span>
    </div>
    <div *ngIf="industryReport?.exit" class="card-sm-wrap">
      <span class="title">Exits</span>
      <span class="number">{{industryReport?.exit}}</span>
    </div>
  </div>

  <div class="overview-section mr-tp sec-desc">
    <h6 class="sec-title">Overview</h6>
    <p [innerHTML]="industryReport?.overview"></p>
  </div>

  <div *ngFor="let deliverable of industryReport?.deliverables" class="section-img-wrap mr-tp sec-desc">
    <h6 class="sec-title" [innerHTML]="deliverable.title"></h6>
    <p [innerHTML]="deliverable.description"></p>

    <div *ngIf="deliverable.creativeType==='BAR_CHART'">
      <ngx-charts-bar-vertical [scheme]="colorScheme2" [results]="deliverable.chartData" [gradient]="gradient"
        [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
        [roundEdges]="false" [barPadding]="16">
        <!-- <ng-template #tooltipTemplate let-model="model">
          <app-ngx-tooltip-component [data]="model" [type]="'bar'"></app-ngx-tooltip-component>
        </ng-template> -->
      </ngx-charts-bar-vertical>
    </div>

    <div *ngIf="deliverable.creativeType==='PIE_CHART'" style="width: 100%;">
      <ngx-charts-pie-chart [scheme]="colorScheme3" [results]="deliverable.chartData" [maxLabelLength]="maxLabelLength"
        [legend]="false" [labels]="true" [tooltipDisabled]="false" [arcWidth]="0.7" [doughnut]="true">
        <!-- <ng-template #tooltipTemplate let-model="model">
          <app-ngx-tooltip-component [data]="model" [type]="'pie'"></app-ngx-tooltip-component>
        </ng-template> -->
      </ngx-charts-pie-chart>
    </div>
    <br />
    <!-- <img src="../assets/images/reportdetail.jpg" class="img" alt="funding" /> -->
  </div>
</section>
